import './loader.css';

export default function Loader({ fullscreen = false }) {
    return (
        <div className={`loader-wrapper${fullscreen ? ' loader-wrapper--fullscreen' : ''}`}>
            <div className="loader-spinner" />
            <span className="loader-text">Loading&hellip;</span>
        </div>
    );
}
